import { Button, Checkbox, Divider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Box, Stack } from '@mui/system'
import React, { useEffect, useState } from 'react'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import { getBookAccSpecialcolumn, getApprAuthority } from '../../constants'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import { clickElement, focusElemnt, navigation3 } from '../../../../common/helper'
import InfoIcon from '@mui/icons-material/Info'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { userRRBookAcSpecialRightsSave } from '../../../../../store/branchAndUserMaster/BUMAction'
import OTPModal from '../OTPModal'
import SuccessfullModal from '../../../../common/SuccessfullModal'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { oTPForUserRoleRight } from '../../../../common/jotaiState/commonStateAtoms'

const BusBookingRights = (props) => {
  const { translations } = useTranslation()
  const bum = translations?.branchAndUserMaster || {}
  const cs = translations?.common || {}
  const BookAccSpecialcolumn = getBookAccSpecialcolumn(translations)
  const ApprAuthority = getApprAuthority(translations)
  const { data, updateModal, busBookRightTableData, setBusBookRightTableData, userRRBookAcSpecialRightsSave, otpOnUserRights, roleId, updateAlertError } = props
  const { common, } = data
  const { loginData } = { ...common }
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'start',
    paddingTop: '5%'
  }
  const [selApprAuth, setSelApprAuth] = useState("")
  const [OtpModal, setOtpModal] = useState(false)
  const [OTP, setOTP] = useState("")
  const [isOpen, setIsOpen] = useState({ open: false, message: "" })
  const [saveError, setSaveError] = useState({ error: false, message: "", })

  useEffect(() => {
    focusElemnt("BBRAppAuth")
  }, [])


  const handleCheckBox = (value, index, field) => {
    let newData = [...busBookRightTableData]
    newData[index][field] = value
    setBusBookRightTableData(newData)
  }
  const sendOTPRequest = () => {
    const obj = {
      strOTPType: "UR",
      intCompanyId: loginData?.intCompanyID,
      intRoleID: roleId,
      intSaveType: 1,
      intOTPSendType: selApprAuth?.id
    }
    oTPForUserRoleRight(obj).then((res) => {
      if (res?.Status == true) {
        setOTP(res.OTP)
        setOtpModal(true)
      } else {
        setOTP("")
        updateAlertError({ show: true, msg: res.ErrMessage })
      }
    }).catch((err) => {
      updateAlertError({ show: true, msg: err })
    })
  }
  const transferArrToObject = (arr) => {
    const newObject = arr.reduce((result, obj) => {
      Object.keys(obj).forEach(key => {
        result[key] = result[key] ? `${result[key]}^${obj[key]}` : `${obj[key]}`;
      });
      return result;
    }, {});
    return newObject
  }

  const saveApi = () => {
    let newData = transferArrToObject(busBookRightTableData)
    const obj = {
      RoleID: roleId,
      BookingRightsIDs: newData?.BookingRightsID,
      Confirm: newData?.Confirm,
      Phone: newData?.Phone,
      AgentConfirm: newData?.AgentConfirm,
      AgentPhone: newData?.AgentPhone,
      BranchConfirm: newData?.BranchConfirm,
      BranchPhone: newData?.BranchPhone,
      Guest: newData?.BookingRightsID
    }
    userRRBookAcSpecialRightsSave(obj).then((res) => {
      if (res?.status == 'Success') {
        setIsOpen({ ...isOpen, open: true, message: bum.busBookingRightsSavedSuccessfullyNl || "Bus Booking Rights\nSaved Successfully!" })
      } else {
        setSaveError({ ...saveError, error: true, message: res.Message })
      }
    }).catch((err) => {
      setSaveError({ ...saveError, error: true, message: err })
    })
  }
  const onSave = () => {
    if (otpOnUserRights == 1) {
      if (selApprAuth === "") {
        updateAlertError({ show: true, msg: bum.selectApprovalAuthority || "Select Approval Authority", nextId: "UmAppAuth" })
      } else {
        sendOTPRequest()
      }
    } else {
      saveApi()
    }
  }
  const handleTblKeyDown = (e, top, bottom, left, right, nextId, prevId, currentId) => {
    if (e.key === ' ') {
      clickElement(currentId)
    } else if (e.key === 'ArrowDown') {
      focusElemnt(bottom)
    } else if (e.key === 'ArrowUp') {
      focusElemnt(top)
    } else if (e.key === 'ArrowLeft') {
      focusElemnt(left)
    } else if (e.key === 'ArrowRight') {
      focusElemnt(right)
    } else if (e.key === 'Escape') {
      focusElemnt(prevId)
    } else if (e.key === 'Enter') {
      focusElemnt(nextId)
    }
  }

  const InsideRowContent = ({ item, index }) => {
    return (
      <TableRow key={`URR-${index}`}>
        <TableCell sx={{ height: '30px', textAlign: 'left', fontSize: '12px', color: '#444', fontWeight: "500" }}>{item.BookingRightsName}</TableCell>
        <TableCell sx={{ height: '30px', textAlign: 'center', fontSize: '12px', color: '#444' }}>
          {
            ![2, 3].includes(item.BookingRightsID) ?
              <Checkbox
                checked={item?.Confirm == 1}
                id={`BBRConfirm-${index}`}
                sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `` : `BBRConfirm-${index - 1}`, index === 16 ? `BBRConfirm-0` : `BBRConfirm-${index + 1}`,
                    `BBRGuest-${index}`, `BBRPhone-${index}`, "BBRAppAuth", "BBRSave", `BBRConfirm-${index}`
                  )}
                onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "Confirm")}
              /> : null
          }
        </TableCell>
        <TableCell style={{ height: '30px', textAlign: 'center', fontSize: '12px', color: '#444' }}>
          {
            ![12, 13].includes(item.BookingRightsID) ?
              <Checkbox
                checked={item?.Phone == 1}
                id={`BBRPhone-${index}`}
                sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `` : `BBRPhone-${index - 1}`, index === 16 ? `BBRPhone-0` : `BBRPhone-${index + 1}`,
                    `BBRConfirm-${index}`, `BBRAgentConfirm-${index}`, "BBRAppAuth", "BBRSave", `BBRPhone-${index}`
                  )}
                onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "Phone")}
              />
              : null
          }
        </TableCell>
        <TableCell style={{ height: '30px', textAlign: 'center', fontSize: '12px', color: '#444' }}>
          {
            ![2, 3, 12, 13].includes(item.BookingRightsID) ?
              <Checkbox
                checked={item?.AgentConfirm == 1}
                id={`BBRAgentConfirm-${index}`}
                sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `` : `BBRAgentConfirm-${index - 1}`, index === 16 ? `BBRAgentConfirm-0` : `BBRAgentConfirm-${index + 1}`,
                    `BBRPhone-${index}`, `BBRAgentPhone-${index}`, "BBRAppAuth", "BBRSave", `BBRAgentConfirm-${index}`
                  )}
                onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "AgentConfirm")}
              />
              : null
          }
        </TableCell>
        <TableCell style={{ height: '30px', textAlign: 'center', fontSize: '12px', color: '#444' }}>
          {
            ![12, 13].includes(item.BookingRightsID) ?
              <Checkbox
                checked={item?.AgentPhone == 1}
                id={`BBRAgentPhone-${index}`}
                sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `` : `BBRAgentPhone-${index - 1}`, index === 16 ? `BBRAgentPhone-0` : `BBRAgentPhone-${index + 1}`,
                    `BBRAgentConfirm-${index}`, `BBRBranchConfirm-${index}`, "BBRAppAuth", "BBRSave", `BBRAgentPhone-${index}`
                  )}
                onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "AgentPhone")}
              />
              : null
          }
        </TableCell>
        <TableCell style={{ height: '30px', textAlign: 'center', fontSize: '12px', color: '#444' }}>
          {
            ![2, 3].includes(item.BookingRightsID) ?
              <Checkbox
                checked={item?.BranchConfirm == 1}
                id={`BBRBranchConfirm-${index}`}
                sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `` : `BBRBranchConfirm-${index - 1}`, index === 16 ? `BBRBranchConfirm-0` : `BBRBranchConfirm-${index + 1}`,
                    `BBRAgentPhone-${index}`, `BBRBranchPhone-${index}`, "BBRAppAuth", "BBRSave", `BBRBranchConfirm-${index}`
                  )}
                onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "BranchConfirm")}
              />
              : null
          }
        </TableCell>
        <TableCell style={{ height: '30px', textAlign: 'center', fontSize: '12px', color: '#444' }}>
          {
            ![12,13].includes(item.BookingRightsID)?
            <Checkbox
              checked={item?.BranchPhone == 1}
              id={`BBRBranchPhone-${index}`}
              sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
              onKeyDown={(e) =>
                handleTblKeyDown(e, index === 0 ? `` : `BBRBranchPhone-${index - 1}`, index === 16 ? `BBRBranchPhone-0` : `BBRBranchPhone-${index + 1}`,
                  `BBRBranchConfirm-${index}`, `BBRGuest-${index}`, "BBRAppAuth", "BBRSave", `BBRBranchPhone-${index}`
                )}
              onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "BranchPhone")}
            />
            :null
          }
        </TableCell>
        <TableCell style={{ height: '30px', textAlign: 'center', fontSize: '12px', color: '#444' }}>
          {
            ![2, 3].includes(item.BookingRightsID) ?
              <Checkbox
                checked={item?.Guest == 1}
                id={`BBRGuest-${index}`}
                sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `` : `BBRGuest-${index - 1}`, index === 16 ? `BBRGuest-0` : `BBRGuest-${index + 1}`,
                    `BBRBranchPhone-${index}`, `BBRConfirm-${index}`, "BBRAppAuth", "BBRSave", `BBRGuest-${index}`
                  )}
                onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "Guest")}
              />
              : null
          }
        </TableCell>
      </TableRow>
    )
  }
  return (
    <>
      <Box sx={{ padding: "16px", paddingBottom: "10px" }}>
        <TableContainer component={Paper} className='scrollBlue' style={{ maxHeight: '70vh', marginBottom: "5px" }} >
          <Table stickyHeader size="small" aria-label="a dense table" sx={{
            '& .MuiTableCell-root': {
              padding: '6px !important'
            }
          }}>
            <TableHead style={{ position: `sticky`, top: `0`, zIndex: "2" }}>
              <TableRow>
                {BookAccSpecialcolumn.map((col, index) =>
                  <TableCell key={`TH-${index}`} style={{ ...col.headerSx, textAlign: index == 0 ? "" : "center", backgroundColor: '#DAEDFE', height: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>{col.headerName}</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
              {busBookRightTableData?.map((item, index) => (
                <InsideRowContent item={item} index={index} key={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Stack className="itemButtons beachTransBottomSec">
        <Divider />
        <Box className='reportButton' sx={{ display: 'flex', justifyContent: "space-between", padding: "16px", paddingBottom: "5px", gap: "12px" }}>
          <Box style={{ display: "flex" }}>
            <Item sx={sx.itemsx} style={{ width: "350px" }} className={'input--wrapper'}>
              <DropDownOA
                id={"BBRAppAuth"}
                data={ApprAuthority || []}
                defaultvalue={selApprAuth?.name || ''}
                width="100%"
                searchPlaceholder={bum.searchBranchName || 'Search Branch Name'}
                label={bum.approvalAuthority || "Approval Authority"}
                dataKey={`name`}
                idKey={`id`}
                nextId={"BBRCancel"}
                field={'compulsory'}
                prevId={"BBRConfirm-0"}
                onSelect={(value) => setSelApprAuth(value)}
              />
            </Item>
            <Box style={{ marginLeft: "5px", display: "flex", alignItems: "center", gap: "5px", fontWeight: "500", fontSize: "13px" }}>
              <InfoIcon style={{ color: "#0086FF" }} />
              <span style={{ color: "#1E59A7" }}>{bum.otpWillSendToManagementAsPerSelection || 'OTP will send to the Management as per Selection'}</span>
            </Box>
          </Box>
          <Box style={{ display: "flex", gap: "15px" }}>
            <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "BBRSave", "BBRAppAuth", () => { })}>
              <Button id={"BBRCancel"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => { updateModal(false, "BookAccSpecialRights"); focusElemnt("URRCatagoryNameInp") }}>
                {bum.cancel || 'CANCEL'}
              </Button>
            </Item>
            <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "BBRConfirm-0", "BBRCancel", () => { })}>
              <Button variant="contained" id="BBRSave" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                onClick={() => onSave()}
              >
                {bum.save || 'Save'}
              </Button>
            </Item>
          </Box>
        </Box>
        {/* */}
      </Stack>
      {OtpModal ? <OTPModal saveApi={saveApi} OTP={OTP} isOpen={isOpen} setIsOpen={setIsOpen} sendOTPRequest={sendOTPRequest} /> : ""}
      <SuccessfullModal modalStyle={modalStyle} handleClose={() => { setIsOpen({ ...isOpen, open: false, message: "" }); updateModal(false, "") }} open={isOpen?.open} title={isOpen?.message} />
      <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => setSaveError({ ...saveError, error: false })} isError={true} open={saveError.error} title={saveError?.message} />
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateModal, updateAlertError, userRRBookAcSpecialRightsSave
}

export default connect(mapStateToProps, mapDispatchToProps)(BusBookingRights)